/* eslint-disable no-unused-vars */
<template>
  <v-card flat>
  
<v-card-title primary-title>
        <h5 class="subheading mb-0">Es ist rechtlich zu empfehlen [*], einen Link auf das Impressum auf Ihrer eigenen Homepage zu setzen. Falls Sie dort keins haben, können Sie auch das Textfeld unten benutzen.</h5>
      </v-card-title>
      <v-card-text>

   <!-- <form v-on:submit="saveForm()"> -->

     <div v-if="this.$store.getters.authBetrieb">
      <form>
         
  <v-layout row>
          <v-flex xs4 class="hidden-xs-only">
            <v-subheader>Link zum Impressum <br>Dieser Text wird zum Teil auf der Startseite angezeigt</v-subheader>
          </v-flex>
          <v-flex xs12 md8>
            <v-text-field
              name="input-1"
              label="Link zu Ihrem Impressum, bitte mitsamt http://"
              v-model="betrieb.impressum_link"
            ></v-text-field>
          </v-flex>
        </v-layout>


    <v-layout row class="mt-5">
          <v-flex xs4 class="hidden-xs-only">
            <v-subheader>Impressum<br>Dieser Text wird auf Ihrem Profil angezeigt, wenn Sie einen Link angegeben haben ist dieses Feld nicht Pflicht.</v-subheader>
          </v-flex>
          <v-flex xs12 md8>
            <v-textarea
              name="input-1"
              label="Impressum"
              
              v-model="betrieb.impressum_text"
              
            ></v-textarea>
          </v-flex>
        </v-layout>


       

    </form>

     <v-layout row>
                           <v-spacer></v-spacer> 
                           <v-btn v-on:click.native="saveForm()" large color="accent">Speichern</v-btn>

                         
                           <v-spacer></v-spacer> 
                       </v-layout>

     </div>
<div v-else>
  
  
   <v-alert outline color="info" icon="info" :value="true">
     Aktuell ist noch kein Betrieb mit Ihrem Nutzer-Account verknüpft, Bitte melden Sie sich bei uns, damit wir Sie verifizieren können: 
        <v-btn href="mailto:info@lokaleshandwerk.de"><v-icon left >mail</v-icon>info@lokaleshandwerk.de</v-btn>

    </v-alert>
</div>
<p>[*]
      <a href="https://www.it-recht-kanzlei.de/impressum-bei-facebook.html" target="_blank">it-recht-kanzlei.de/impressum-bei-facebook.html</a><br>
      <a href="http://geld-im-netz.de/facebook-impressum-ist-pflicht-was-ist-zu-beachten/" target="_blank">geld-im-netz.de/facebook-impressum-ist-pflicht-was-ist-zu-beachten/</a></p>

  </v-card-text>


  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    betrieb: ''
  },
  mounted () {

  },
  data: function () {
    return {
      companyId: '',
      company: {
        name: '',
        address: '',
        website: '',
        email: '',
        kurztext: ' '
      }

    }
  },
  methods: {
    saveForm () {
      var app = this
      var newCompany = app.betrieb

      axios.patch('/api/v1/companies/' + app.betrieb.id, newCompany)
      .then((resp) => {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('betrieb_updated')
        })

      //

        app.$router.replace('/meinbetrieb')
      })
    .catch((resp) => {
      this.$store.dispatch('responseMessage', {
        type: 'error',
        text: this.$t('error_alert_text')
      })
    })
    }
  }

}
</script>
